import styled from 'styled-components';

export const InputContainer = styled.div`
  margin: 1rem 0;
`;
